import { render, staticRenderFns } from "./LeftNav.vue?vue&type=template&id=4d9f0810&"
import script from "./LeftNav.vue?vue&type=script&lang=js&"
export * from "./LeftNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports